import React from 'react'
import HelpContent from './HelpContent'

export default function HelpPage () {
  return (
    <div className='helpPage mobile'>
      <HelpContent isMobile={true} />
    </div>
  )
}
